<script>
    export let content = [];
    export let modulePosition;
    export let sectionPosition;

    const items = content?.items;

    const convertScale = (number) => {
        let str = number?.toString();
        return str.length > 1 ? parseInt(str[str.length - 2]) : 0;
    };
</script>

<div class="flex flex-col gap-4" data-moduleposition={modulePosition}>
    {#each items as item (item)}
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-3 lg:col-span-2">{item?.title}</div>
            <div class="col-span-9 w-full rounded-3xl bg-base-800 lg:col-span-10">
                <div class="featured-gradient flex h-6 flex-col items-end justify-center rounded-3xl shadow-xl lg:h-8" style="width:{item?.value}%">
                    <span class="px-2 text-[0.7rem] text-white">
                        {#if item?.value > 10}
                            {convertScale(item?.value)} / 10
                        {/if}
                    </span>
                </div>
            </div>
        </div>
    {/each}
</div>
